import createIcon from '../../createIcon';

/**
 * @component @name Exposure
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk02IDdIMTFWOC41SDZWN1pNMTkgMTlINUwxOSA1VjE5Wk0xNC41IDE2VjE4SDE2VjE2SDE4VjE0LjVIMTZWMTIuNUgxNC41VjE0LjVIMTIuNVYxNkgxNC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Exposure = createIcon('Exposure', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM6 7H11V8.5H6V7ZM19 19H5L19 5V19ZM14.5 16V18H16V16H18V14.5H16V12.5H14.5V14.5H12.5V16H14.5Z',
      key: 'cs3z1z',
    },
  ],
]);

export default Exposure;
